import { SendMailParams } from "./models/mail";
import { environment as env } from '../environments/environment';

export const productionTitle = 'Kamo' as const
const crewtimeLink = 'https://kamo.crewtime.app' as const
const financeEmail = 'kamo.finance@protoncinema.hu' as const
const pmEmail = 'pajor.dora@gmail.com' as const
export const invoiceMainualLink = 'https://drive.google.com/file/d/13vQTioxtAyQrfmlTjKXo33GSYWqu-nJ3/view' as const 

export const config = {
    dev: { name: "SÓS András", email: 'sosandris@gmail.com' },
    /** Ha ezek a userek közül van valaki bejelentkezve, 
     * akkor email küldés előtt kérdezz rá, hogy biztos ki akarja-e küldeni. 
     * Jó eséllyel csak tesztelgetünk, és nem akarjuk ténylegesen elküldeni az emailt. */
    DONT_SEND_MAIL: [/^sosandris@gmail.com$/, /@tu.tu$/, /^sergeikov@gmail.com$/, /^zoltantokey@gmail.com$/],
    SHOW_GROWING_OTTA_RATE: false,
    CONFIG_PERSONAL_END_DATES: true,
    AUTOFILL_CONTRACT_DATES: true,
    HAS_FOREIGN_CREW: false,
    ALLOW_TRAVELDAY: false as boolean | 'onlyForMoreThanDeptHead',

    ALLOW_CREW_MEMBER_EDIT_FEES: true,
    HIDE_FEES_IF_HAS_INVOICE_CONTACT: false,
    DISABLE_OLD_TS: true,
    DISABLE_OLD_TS_OT: true,
    DISABLE_OLD_TS_PREP_WEEKS: 2 as false | number,
    DISABLE_OLD_TS_SHOOTING_WEEKS: 2 as false | number,
    DISPLAY_CALC_FEES_BEFORE_SUBMIT_TS: true,
    ALLOW_CREW_MEMBER_EDIT_OT_FEE: false,
    ALLOW_CREW_MEMBER_EDIT_OT_STEP: false,
    ALLOW_CREW_MEMBER_EDIT_TA_FEE: false,
    ALLOW_CREW_MEMBER_EDIT_CONTRACT_DATES: true,
    ALLLOW_CONTRACT_END_DATE: true,
    ALLOW_PERDIEM: false as boolean | 'onlyForMoreThanDeptHead',
    ALLOW_OT_PERCENT: true,
    OT_PERCENT: 15,
    ALLOW_TA_PERCENT: true,
    TA_PERCENT: 15,
    MAX_ALLOWED_OTTA_PERCENT: 25,
    ALLOW_REST_DAY: true as boolean | 'onlyForMoreThanDeptHead',
    ALLOW_WORK_ON_REST_DAY: false,
    PERDIEM_MULTIPLIER_FOR_REST_DAY: 1,
    HUF_PER_KM: 75,
    REPORT: {
        CURRENCY: 'USD' as string | undefined,
    },
    
    /** 'fixed-rates': Nem adható meg naponta új árfolyam. Ha több mint 2 pénznem van, akkor csak ez választható, mert a napi árfolyam mentésekor nem adható meg, hogy melyik pénznam árfolyamát mented */
    MULTIPLE_CURRENCIES: 'fixed-rates' as 'fixed-rates' | boolean,

    DISABLED_TS_HISTORY_TEXT: 'Letiltva',
    UPLOAD_ALLOW_FILETYPES: ["pdf"], //["pdf", "jpg", "jpeg", "png", "tiff"],
    
    HU: {
        CONTRACT: {
            ENABLE_FILTER_FINANCE_APPROVED: true,
            CONTRACT_GEN_FEATURE: true,
            ALLOW_PROD_MGR_APPROVE_UNSUBMITTED_CONTRACT: false,
            SEND_MAIL_FOR_SENDBACK_TO_CREW: {
                ccTo: pmEmail,
                subject: `[${productionTitle}] Start Form visszaküldve`,
                body: `Kedves {USERNAME}!<br><br>A Start Formodat {FROM_USER} visszaküldte javításra. Kérlek, javítsd ki a hibákat, és küldd be újra a ${crewtimeLink} címen.`,
                bodyEnding: '<br><br>Köszönjük!<br>CrewTime',
            },
            SEND_MAIL_FOR_APPROVED: {
                enabled: false,
                sendTo: financeEmail,
                subject: `[${productionTitle}] Start Form elfogadva`,
                body: `Kedves Andi!<br><br>A következő Start Formot jóváhagyták: {START_FORM}. Megtekintheted a ${crewtimeLink} címen.<br><br>Üdvözlettel!<br>CrewTime`,
            },
            SEND_MAIL_FINANCE_NOTIF_NEW_POSITION: {
                enabled: false,
                sendTo: financeEmail,
                subject: `[${productionTitle}] Új pozíció jóváhagyva`,
                body: `Sziasztok! <br><br> A következő Start Formot új pozícióval, de megegyező céggel jóváhagyták: {START_FORM}. Megtekintheted a ${crewtimeLink} címen.<br><br>Üdvözlettel!<br>CrewTime`,
            }
        },
        USER: {
            SEND_MAIL_FOR_REG_ACCEPTED: {
                subject: `[${productionTitle}] Regisztráció elfogadva`,
                body: `Kedves {USERNAME}!<br><br>A regisztrációdat elfogadtuk. Kérlek, töltsd ki a start formodat a ${crewtimeLink} címen.<br><br>Köszönjük!<br>CrewTime`,
            },
        },
        TS: {
            SEND_MAIL_FOR_SENDBACK_TO_CREW: {
                ccTo: pmEmail,
                subject: `[${productionTitle}] Timesheet visszaküldve`,
                body: `Kedves {USERNAME}!<br><br>A {TS_START_DATE}-i Timesheetedet {FROM_USER} visszaküldte javításra. Kérlek, javítsd ki a hibákat, és küldd be újra a ${crewtimeLink} címen.`,
                bodyEnding: '<br><br>Köszönjük!<br>CrewTime',
            },
            /** timeFromCrewCallFirstValueableOtRate: a crew calltól számított x idő után jár egy egyösszegű díj. Az összeg az első órára járó túlóra díjával egyezik meg
             * Az összeg az első órára járó túlóra díjával egyezik meg
             * setAtProdDeptSf: A produkció / részleg start formján beállított összeg kerül kiszámolásra
             * false: nem jár senkinek
             */
            MEAL_PENALTY: 'setAtProdDeptSf' as 'firstValueableOtRate' | 'setAtProdDeptSf' | 'timeFromCrewCallFirstValueableOtRate' | false,
            // MEAL_PENALTY: false as 'firstValueableOtRate' | 'setAtProdDeptSf' | 'timeFromCrewCallFirstValueableOtRate' | false,
            /** A Crew Calltól számított hány óó:pp után kapja a MEAL_PENALTY-t
             * Csak ha a timeFromCrewCall van beállítva a MEAL_PENALTY-nek */
            MEAL_PENALTY_START_AFTER_CREW_CALL: '6:15',
            /** A start formban megjelenő label szöveg. Ha null, akkor a dictionary-ből jön ("meal-penalty-label"-> Meal Penalty egy teljes órára) */
            MEAL_PENALTY_SF_LABEL: 'Meal Penalty' as null | string,
            /** Csak ha MEAL_PENALTY==setAtProdDeptSf. Ha true, negyedórás lépcsőben kérhető MP. Ha false, akkor 1 óra vagy semmi  */
            MEAL_PENALTY_15_MIN: false,
            DISPLAY_KM_PARKING_VIGN_IN_CALCULATED_SECTION: true,
            // Ha nem kell pénzügyes jóváhagyás, akkor , 
            ALLOW_SUBMIT_BEFORE_APPROVAL: false,
            WARN_NUM_CONSEQ_DAYS: 7 as number | false,
            HIDE_KM_FEE: false,
            /** Mikor mutassuk, hogy hány TS lett összesen leadva
             * false: soha,
             * true: mindig,
             * 'onlyWhenPlannedDaysFilledOut': csak akkor, ha ki van töltve a tervezett napok száma (f_numPlannedDays) */
            DISPLAY_NUM_TS: 'onlyWhenPlannedDaysFilledOut' as boolean | 'onlyWhenPlannedDaysFilledOut',
            DISPLAY_SUM_DAYS: true,
        },
    },
} as const

export const POLICIES = {
    PRIVACY_POLICY: {
        hu: { title: 'Adatvédelmi Szabályzat', url: 'https://drive.google.com/file/d/1qZR5Ze1VmVhDiFo_H8-1XriuxahfeOI6/view?usp=drive_link' },
        en: { title: 'Privacy Policy', url: 'https://drive.google.com/file/d/1qZR5Ze1VmVhDiFo_H8-1XriuxahfeOI6/view?usp=drive_link' },
    },
    /** Terms & Conditions */
    GENERAL_TC: {
        hu: { title: 'Általános Szerződési Feltételek', url: 'https://drive.google.com/file/d/1CBEDu0Kxp36cpT27ThIyzw8EA1T67JY-/view?usp=drive_link'},
        en: { title: 'General Terms & Conditions', url: 'https://drive.google.com/file/d/1CBEDu0Kxp36cpT27ThIyzw8EA1T67JY-/view?usp=drive_link'},
    },
    HARASSMENT: {
        hu: { title: 'Zaklatás elleni irányelvek', url: 'https://docs.google.com/document/d/10eVFo7Px0A45qIEp2k3-ZAXAKShrleI2/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
        en: { title: 'Harassment Policy', url: 'https://docs.google.com/document/d/10eVFo7Px0A45qIEp2k3-ZAXAKShrleI2/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
    },
    ETHICS: {
        hu: { title: 'Etikai irányelvek', url: 'https://docs.google.com/document/d/18V8V9PwMNmG7HpvbqBfw580hQqmT5Uwg/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
        en: { title: 'Ethics Policy', url: 'https://docs.google.com/document/d/18V8V9PwMNmG7HpvbqBfw580hQqmT5Uwg/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
    },
    NDA: {
        hu: { title: 'Titoktartási Megállapodás', url: null, },
        en: { title: 'Non-Disclosure Agreement', url: null, },
    },
    HEALTH_AND_SAFETY: {
        hu: { title: 'Egészség és Biztonság', url: null, },
        en: { title: 'Health and Safety', url: null, },
    },
    EQUALITY_DIVERSITY_INCLUSION: {
        hu: { title: 'Egyenlőség, Sokszínűség és Befogadás', url: null, },
        en: { title: 'Equality, Diversity and Inclusion', url: null, },
    },
    DATA_PRIVACY: {
        hu: { title: 'Adatvédelem', url: null, },
        en: { title: 'Data Privacy', url: null, },
    },
    ANTI_BRIBERY: {
        hu: { title: 'Visszaélés elleni irányelvek', url: null, },
        en: { title: 'Anti-Bribery Policy', url: null, },
    },
} as const

export const IS_RAGE = (productionTitle as unknown == 'RAGE' as const)
export const IS_DENNIS = (productionTitle as unknown == 'Dennis' as const)
    || (productionTitle as unknown == 'Nevermore' as const)
